<template>
    <div>
      <base-header class="pb-6">
        <div class="row align-items-center py-4">
          <div class="col-md-6 mb-3 mb-md-0">
            <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </div>
          <div class="col-md text-md-right">
            <base-button class="rounded-pill" tag="a" type="celcompink" href="/envios/nuevo-envio">
              Nuevo Envio
              <i class="fas fa-plus-circle fa-lg text-pink"></i>
            </base-button>
          </div>

        </div>
      </base-header>

      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">

            <div class="card">
              <div class="card-header mb-4">

                <div class="d-flex justify-content-md-end">
                  <base-input v-model="keySearch"
                              prepend-icon="fas fa-search"
                              placeholder="Buscar..."
                              class="mb-0">
                  </base-input>
                </div>

              </div>

              <div class="col-12">
                <el-table class="table-responsive table-flush table-striped"
                        header-row-class-name="thead-light"
                        :data="queriedData">
                  <el-table-column label="Nombre"
                                   prop="name"
                                   min-width="200px"
                                   sortable>
                      <template v-slot="{row}">
                          <div class="media align-items-center">
                              <div class="media-body">
                                  <a href="#!" @click.prevent="onEditSending(row)" class="font-weight-600 mb-0 text-sm text-celcomblue">{{row.name}}</a>
                              </div>
                          </div>
                      </template>
                  </el-table-column>
                  <el-table-column label="Fecha Envío"
                                   prop="calendar"
                                   min-width="200px"
                                   sortable>
                      <template v-slot="{row}">
                                {{ fechaFormato(row.calendar) }}
                      </template>
                  </el-table-column>


                  <el-table-column label="Lista / Numero"
                                   min-width="150px"
                                   prop="receiverType"
                                   sortable>
                      <template v-slot="{row}">
                                {{ getInfoContacList2(row) }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Contactos"
                                   min-width="150px"
                                   prop="receiverType"
                                   sortable>
                      <template v-slot="{row}">
                                {{ getInfoContacList(row) }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Estado"
                                   prop="aborted"
                                   min-width="150px"
                                   sortable>
                      <template v-slot="{row}">
                          <badge class="mr-4" :type="(row.aborted!=true) ? 'success' : 'danger'">
                              <span class="status">{{ (row.aborted!=true) ? "Activo" : "Inactivo" }}</span>
                          </badge>
                      </template>
                  </el-table-column>
                  <el-table-column label="Acción" min-width="150px">
                      <div slot-scope="{row}" class="table-actions">
                        <el-tooltip content="Eliminar" placement="top">
                          <a href="#!" @click.prevent="onAbortSending(row)" class="table-action table-action-delete" data-toggle="tooltip"
                            data-original-title="Eliminar envio">
                            <i class="fas fa-trash"></i>
                          </a>
                        </el-tooltip>

                        <el-tooltip content="Editar" placement="top">
                          <a href="#!" @click.prevent="onEditSending(row)" class="table-action table-action-edit" data-toggle="tooltip"
                            data-original-title="Editar Envio">
                            <i class="fas fa-edit"></i>
                          </a>
                        </el-tooltip>

                      </div>
                    </el-table-column>

                </el-table>
              </div>

              <div
                slot="footer"
                class="col-12 mt-4 d-flex justify-content-around justify-content-sm-between flex-wrap mb-4 align-items-center"
              >
                  <div class="">
                    <small class="card-category">
                      Mostrando {{ from + 1 }} de {{ to }}  -  {{ total }} entradas

                      <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                      </span>
                    </small>

                  </div>

                  <div class="d-flex align-items-center flex-sm-row flex-column mt-sm-3">

                    <el-select class="select-primary pagination-select mb-3 mb-sm-0 mr-3"
                                v-model="pagination.perPage"
                                placeholder="Per page" >
                      <el-option class="select-primary"
                                  v-for="item in pagination.perPageOptions"
                                  :key="item"
                                  :label="item"
                                  :value="item" >
                      </el-option>
                    </el-select>
                    <base-pagination
                      class="pagination-no-border mb-0"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="total"
                    >
                    </base-pagination>

                  </div>

              </div>
            </div>

          </div>
        </div>

        <div class="row">


          <modal :show.sync="modals.advertenciaGroup"
                gradient="danger"
                modal-classes="modal-danger modal-dialog-centered">
              <h6 slot="header" class="modal-title" id="modal-title-notification">Borrar lista</h6>

              <div class="text-center">
                  <i class="fas fa-exclamation-circle ni-3x mb-3"></i>
                  <p class="mb-0">Estás a punto de eliminar esta lista.</p>
                  <span>{{ contactSingle.name }}</span>
              </div>

              <template slot="footer">
                  <base-button type="white text-danger"
                               @click="borrarSending(contactSingle)">
                      Borrar
                  </base-button>
                  <base-button type="link"
                               class="ml-auto text-white"
                               @click="modals.advertenciaGroup = false">
                      Cerrar
                  </base-button>
              </template>
          </modal>

        </div>

      </div>

  </div>
</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui'
  import { BasePagination, Modal, Dialog } from '@/components';
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload';

  import moment from 'moment';
  import XLSX from 'xlsx';
  import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';

  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora,search_data,getUserSub } from '@/util/util.js';
  import swal from 'sweetalert2';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)

  export default {
    mixins: [clientPaginationMixin],
    components: {
      DropzoneFileUpload,
      BasePagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      Modal,
      Dialog
    },
    data() {
      return {
        keySearch:"",
        currentPage: 1,
        tableData: [],
        selectedRows: [],
        listaNombre: "",
        contactSingle: {},
        selectOptionsListContact:[],
        modals: {
          detalleEnvio: false,
          advertenciaGroup: false,
        },
        fileSingle: [],
      };
    },
    methods: {



      getInfoContacList(row){


        var can = 0;

        if(row.receiverId == null){

          return  1;

        }

          this.selectOptionsListContact.forEach(function(key) {
            if (row.receiverId == key.contactGroupId) {
              can = (key.validos+ key.invalidos)
            }
        });


        return can

      },

      getInfoContacList2(row){


        var can = 0;

        if(row.receiverId == null){

          return  row.phoneCode+""+row.phone;

        }

          this.selectOptionsListContact.forEach(function(key) {
            if (row.receiverId == key.contactGroupId) {
              can = key.name
            }
        });


        return can

      },

       loadGroupContact(){

      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

     Vue.axios.post(Config.url_service+Config.contact_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {

              self.selectOptionsListContact = response.data.data;

            } else {
              console.log("No se encontró lista de contacto");
            }


        })
        .catch(function (error) {
            console.log("No se encontró lista",error);
        });

      },
     obtenerLista() {

      this.$loading.show()   //delay default is 300ms

      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer_user":encodeURIComponent(JSON.stringify(user)),
        "customer":encodeURIComponent(JSON.stringify(user.customer))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.sending_sms_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {
              console.log(response.data.data);

              self.tabContact = false;
              self.tableData = response.data.data;

            } else {
              console.log("No se encontró lista");
              alert("No se encontró lista");
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontró lista",error);
            alert("No se encontró lista");
            self.$loading.hide();
        });

      },

      onAbortSending(row) {

        let self = this;
        let modals = modals;

        self.contactSingle = row;
        self.modals.advertenciaGroup = true;

      },
      onEditSending(row) {

        window.location.href="/envios/nuevo-envio?sending_sms="+row.sendingSmsId

      },

      borrarSending(contactGroup) {


        this.modals.advertenciaGroup = false;

        this.$loading.show()

        let self = this;
        let user = (getUserSub()!=null) ? getUserSub() :getUser();

        let js = {
          "time_expired":horaAhora(),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
          "customer_user":encodeURIComponent(JSON.stringify(user)),
          "sending_sms":encodeURIComponent(JSON.stringify(contactGroup)),
          "application_id":1,
        }

        console.log("borrar envios",js)

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.sending_sms_abort, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {
              console.log(response)

              if (response.data.response === "200") {
                console.log(response.data.data);

                swal({
                  text: 'Envio programado borrado exitosamente!',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success',
                  type: 'success',
                  }).then(function() {
                      window.location.href = "/envios/envios-programados";
                })

              }else{


                swal({
                  title: "Error borrado envio programado ",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })



              }

              self.$loading.hide()

          })

      },
      fechaFormato(unixTimestamp) {
        return moment(unixTimestamp).format('YYYY-MM-DD HH:mm:ss');
      },
    },
    mounted() {
      this.obtenerLista();
      this.loadGroupContact();
    },
    create() {
      this.$loading.show();
    },
    watch: {

      'keySearch'(newVal){
          if(newVal.toString().length>3){
            this.searchedData = search_data(newVal, this.tableData);
          }else{
            this.searchedData = this.tableData;
          }
      },

    },
    computed: {

    }
  }
</script>

<style>
.modal-secondary .close > span:not(.sr-only) {
  color: #172b4d;
}
.busy-mask {
  z-index: 1051;
}
</style>
